import { render, staticRenderFns } from "./CategorySearch.vue?vue&type=template&id=5c44fd58&"
import script from "./CategorySearch.vue?vue&type=script&lang=ts&"
export * from "./CategorySearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports